<template>
  <div class="tabs-section-container">
    <div class="row row-cols-auto row-tabs">
      <div
        class="col col-auto mt-4 col-tab"
        v-for="(tab, index) in tabs"
        :key="tab.key"
      >
        <span
          class="outfits-title text-uppercase"
          :class="{
            'outfits-title-active': tabs[activeTabIndex]['key'] === tab.key,
          }"
          variant="link"
          @click="goToTab(index)"
        >
          {{ tab.label }}
          <span class="badge rounded-pill">
            {{ badgeNumber(tab.key) }}
          </span>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="sections-content-wrapper">
          <transition :name="chooseDirection">
            <keep-alive>
              <component :is="tabs[activeTabIndex].key" class="wrap-wrap" />
            </keep-alive>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OutfitsTab from "./tabs/OutfitsTab";
import WearLikeThisTab from "./tabs/WearLikeThisTab";
import { mapGetters } from "vuex";

export default {
  components: {
    OutfitsTab,
    WearLikeThisTab,
  },

  data() {
    return {
      activeTabIndex: 0,
      forwards: true,
      tabs: [
        { label: "Stitched Outfits", key: "OutfitsTab" },
        { label: "Wear it like this", key: "WearLikeThisTab" },
      ],
    };
  },

  computed: {
    ...mapGetters(["currentCapsule"]),

    chooseDirection() {
      return this.forwards == true ? "page" : "page-back";
    },
  },

  methods: {
    goToTab(index) {
      this.forwards = this.activeTabIndex > index ? false : true;
      this.activeTabIndex = index;
    },

    badgeNumber(key) {
      if (key == "OutfitsTab") {
        return this.currentCapsule.outfits_count;
      } else if (key == "WearLikeThisTab") {
        return this.currentCapsule.wear_like_this_images_count;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.tabs-section-container {
  margin-left: -15px;
  margin-right: -15px;

  @include for-tablet-portrait-up {
    margin-left: inherit;
    margin-right: inherit;
  }
}

.row-tabs > .col-tab {
  padding-right: 0;

  &:not(:first-child) {
    padding-left: 0px;
  }
}

.outfits-title {
  cursor: pointer;

  bottom: 12px;
  border-bottom: 0;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-radius: 0;
  color: $primary-blue;
  font-size: 0.75rem;
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 1.5;
  padding: 0.9rem 0.77rem;
  position: relative;
  z-index: 1;

  @include for-tablet-portrait-up {
    font-size: 0.9rem;
    padding: 0.9rem 2rem;
  }

  .badge {
    background-color: lighten($grey5, 5%);
    color: $grey3;
  }

  &.outfits-title-active {
    background: $grey6;
    border: 1px solid transparent;
    border-color: #dee2e6 #dee2e6 #ffffff;
    font-size: 0.8rem;

    @include for-tablet-portrait-up {
      font-size: 1rem;
    }

    .badge {
      background-color: $primary-blue;
      color: white;
    }
  }
}

.sections-content-wrapper {
  background: $grey6;
  border-top: 1px solid $primary-accent;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
  border-top-right-radius: 0.25rem;
  display: inherit;
  min-height: 500px;
  overflow-x: auto;
  padding: 15px;
  position: relative;

  .wrap-wrap {
    margin-top: 40px;
    margin-bottom: 40px;
    width: 100%;
    height: 100%;
  }
}

$percentage: 40%;

// Forwards transition

.page-enter {
  opacity: 0;
  transform: translateX($percentage);
  position: initial;
}

.page-enter-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: initial;
}

.page-leave-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  transform: translateX(-$percentage);
  position: absolute;
}

// Backwards transition

.page-back-enter {
  opacity: 0;
  transform: translateX(-$percentage);
}

.page-back-enter-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.page-back-leave-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  transform: translateX($percentage);
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/showCapsule/TabsSection.vue